<template>
  <nav class="buheader-bottom__nav py-2 px-4">
    <ul class="d-flex flex-row justify-content-center flex-wrap">
      <li class="nav-item px-4 py-2">
        <router-link class="nav-link" :to="`/bedrijvengids/${$route.params.slug}`" exact>
          Home
        </router-link>
      </li>
      <li
        v-for="(item, index) in menu"
        :key="index"
        class="nav-item px-4 py-2"
      >
        <a
          v-if="item.type === 'enjoj\\feed\\UrlItem'"
          class="nav-link"
          :href="item.itemable.url"
          target="_blank"
          v-html="item.text"
        />
        <router-link
          v-else class="nav-link"
          :to="getRoute(item)"
          v-html="item.text"
        />
      </li>
    </ul>
  </nav>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'ec-business-header-menu',
  props: {
    menu: {
      type: Array,
      default () {
        return []
      }
    }
  },
  methods: {
    getRoute (item) {
      const route = `/bedrijvengids/${this.$route.params.slug}/${_.kebabCase(item.text)}`
      return route
    }
  }
}
</script>
